import { uniqueId } from 'lodash';

import * as OvationsApi from 'core/ovations-api';
import {
    emptyQuestion,
    textQuestion,
    dateTimeQuestion,
    dropdownQuestion,
    fileUploadQuestion,
    numberQuestion,
    cascadingDropdownQuestion,
    multiSelectQuestion,
} from './question';

const mockDateString = new Date().toISOString();

export const emptyPromotionQuestion: OvationsApi.Types.PromotionQuestion = {
    id: '',
    dateAdded: mockDateString,
    hideOnPortal: false,
    promotionId: 'promotion-1',
    readOnlyOnPortal: false,
    readOnlyOnCallCenter: false,
    requiredOnPortal: false,
    requiredOnCallCenter: false,
    question: emptyQuestion,
    type: OvationsApi.Enums.QuestionType.None,
    validateOnCallCenter: false,
    needsReview: false,
    checkForDuplicate: false,
    isForPreFund: false,
    displayOnPortalHistory: false,
    promotionQuestionId: 1,
};

export const promotionTextQuestion: OvationsApi.Types.PromotionTextQuestion = {
    ...emptyPromotionQuestion,
    type: OvationsApi.Enums.QuestionType.Text,
    id: uniqueId(),
    question: textQuestion,
    minimumCharacters: 0,
    maximumCharacters: 1,
};

export const promotionDateTimeQuestion: OvationsApi.Types.PromotionDateTimeQuestion = {
    ...emptyPromotionQuestion,
    type: OvationsApi.Enums.QuestionType.DateTime,
    id: uniqueId(),
    question: dateTimeQuestion,
    startDate: mockDateString,
    endDate: mockDateString,
    startDateCustomerAttributeId: 1,
    endDateCustomerAttributeId: 2,
    timeFrameType: OvationsApi.Enums.DateTimeframeType.SpecificDates,
    allowFutureDates: false,
};

export const promotionDropdownQuestion: OvationsApi.Types.PromotionDropdownQuestion = {
    ...emptyPromotionQuestion,
    type: OvationsApi.Enums.QuestionType.Dropdown,
    id: uniqueId(),
    question: dropdownQuestion,
    options: ['a', 'b', 'c'],
    sortDirection: OvationsApi.Enums.DropdownSort.None,
};

export const promotionFileUploadQuestion: OvationsApi.Types.PromotionFileUploadQuestion = {
    ...emptyPromotionQuestion,
    type: OvationsApi.Enums.QuestionType.FileUpload,
    id: uniqueId(),
    question: fileUploadQuestion,
    allowedFileTypes: [],
};

export const promotionNumberQuestion: OvationsApi.Types.PromotionNumberQuestion = {
    ...emptyPromotionQuestion,
    type: OvationsApi.Enums.QuestionType.Number,
    id: uniqueId(),
    question: numberQuestion,
    numberOfDecimalPlaces: 0,
    minimumValue: 0,
    maximumValue: 1,
};

export const promotionCascadingDropdownQuestion: OvationsApi.Types.PromotionCascadingDropdownQuestion = {
    ...emptyPromotionQuestion,
    type: OvationsApi.Enums.QuestionType.CascadingDropdown,
    id: uniqueId(),
    question: cascadingDropdownQuestion,
};

export const promotionMultiSelectQuestion: OvationsApi.Types.PromotionMultiSelectQuestion = {
    ...emptyPromotionQuestion,
    type: OvationsApi.Enums.QuestionType.MultiSelect,
    id: uniqueId(),
    question: multiSelectQuestion,
    options: ['test1', 'test2', 'test3'],
    sortDirection: OvationsApi.Enums.DropdownSort.None,
};
